import { cn } from '@/utils'
import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { Button } from '@/components/ui/button'
import { CameraRetakeIcon } from '@/components/icons/CameraRetakeIcon'
import { useRetakeView } from '@/utils/hooks/useRetakeView'
import { useCADPageStore } from '@/state'
import { Spinner } from '@/components/ui/spinner'

export const RetakeViewButton = () => {
  const retakeViewId = useCADPageStore(
    useShallow((state) => state.retakeViewId),
  )
  const setHover = useCADPageStore(
    useShallow((state) => state.setCreateViewButtonHover),
  )

  const { isLoading, isViewPending, retakeView } = useRetakeView(retakeViewId)

  const isRetakeViewButtonDisabled = useMemo(
    () => isLoading || !retakeViewId,
    [isLoading, retakeViewId],
  )

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div
            onMouseOver={() => {
              if (!isRetakeViewButtonDisabled) setHover(true)
            }}
            onMouseOutCapture={() => setHover(false)}
          >
            <Button
              type="button"
              disabled={isLoading || !retakeViewId}
              className={cn('w-20 h-12 rounded-full shadow-md')}
              onClick={retakeView}
            >
              <div className="flex items-center space-x-2">
                {isViewPending ? (
                  <Spinner className="w-5" />
                ) : (
                  <CameraRetakeIcon
                    className={cn('h-8 w-8 relative left-px stroke-white')}
                  />
                )}
              </div>
            </Button>
          </div>
        </TooltipTrigger>
        <TooltipContent className="bg-black text-white">
          <p>Retake View</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
